export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "container_final_quality": {
            "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calidad"])},
            "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])},
            "comments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comentarios"])},
            "statuses": {
              "rejected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechazado"])},
              "medium_quality": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calidad media"])},
              "high_quality": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calidad alta"])}
            }
          }
        }
      },
      "en": {
        "model": {
          "container_final_quality": {
            "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality"])},
            "container": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])},
            "comments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Comments"])},
            "statuses": {
              "rejected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rejected"])},
              "medium_quality": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Medium quality"])},
              "high_quality": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["High quality"])}
            }
          }
        }
      }
    }
  })
}